<template>
  <div :dir="isHebrew ? 'rtl' : 'ltr'">
    <div 
      v-if="allRide?.ride && isUserManager && compareToUserId(allRide.ride.authorId) && !isNewAttractionEditMode"
      class="btn-toolbar" >
      <div
        ref="floatingRoot"
        class="add-new-activity-add-icon-sticky"
        :style="floatingStyle"> 
        <div 
          class="centering"
          >
          <b-btn
            pill
            variant="warning"
            class="single-ride-add-activity-btn single-ride-add-activity-btn_colors centering-with-start"
            @click="serchAttractionToRide(newAttractionPlannedDateIndex)"
          >
          <div class="add-new-activity-add-icon">
            <p>+</p>
          </div>
          <div class="add-new-activity-add-icon-text">
            {{ t('attractionEditingAddFromMyList') }}
          </div>
          </b-btn>
        </div>
      </div>
    </div>
   
   
   
   <SingleRideHeader
      :presentedText="t('attractionEditingPresentedText')"
   />
      <div class="trip-card-section">
        <div class="container">
          <div class="trip-card-top trip-card-top2">
            <a
              v-if="this.allRide?.ride?.id"
              class="trip-btn-bg btn-greey"
              @click="ReturnToSingleRide()">
              {{ t('attractionEditingBackToTrip') }}
            </a>
            <a
              v-else
              class="trip-btn-bg btn-greey"
              @click="gooToRideManagerAttraction()">
              {{ t('attractionEditingBackToAttractionsEdit') }}
            </a>
            <h4>{{ t('attractionEditingActivityDetailsTitle') }}</h4>
          </div>
        </div>
      </div>
      <!-- End card section -->

      <div class="trip-contact-form-section">
        <div class="container">
          <div class="trip-contact-wrap">
            <h4>{{ t('attractionEditingActivityDetailsTitle') }}</h4>
            <div class="row">
              <div class="col-lg-5 offset-lg-3">
                <div class="trip-contact-column">
                  <!-- Stage 1: Only show autocomplete -->
                  <div v-if="!isPlaceSelected" class="trip-contact-field">
                    <div class="attraction-editing-intro">
                      {{ t('attractionEditingAutocompleteIntro') }}
                    </div>
                    
                    <!-- Video Tutorials Section -->
                    <div class="video-tutorials-section">
                      <div class="video-tutorials-title">
                        <span class="icon">🎥</span> {{ t('attractionEditingTutorialsRecommendedTitle') }}
                      </div>
                      <div class="video-tutorials-list">
                        <div 
                          v-for="(video, index) in tutorialVideos" 
                          :key="index"
                          class="video-tutorial-item"
                        >
                          <div 
                            class="video-tutorial-card"
                            @click="toggleVideo(index)"
                          >
                            <div class="video-tutorial-header">
                              <div class="video-tutorial-title">{{ t(video.titleKey) }}</div>
                              <span class="video-tutorial-arrow" :class="{ 'is-open': selectedVideoIndex === index }">
                                ▶
                              </span>
                            </div>
                          </div>
                          <transition name="slide-down">
                            <div v-if="selectedVideoIndex === index" class="video-container-wrapper">
                              <div class="tutorial-video-container">
                                <video 
                                  v-if="video.videoUrl && !video.error"
                                  :ref="`video-${index}`"
                                  :src="video.videoUrl"
                                  controls
                                  class="tutorial-video"
                                  @loadstart="onVideoLoadStart(index)"
                                  @error="onVideoError(index)"
                                  @loadeddata="onVideoLoaded(index)"
                                  preload="none"
                                >
                                  {{ t('videoTagNotSupported') }}
                                </video>
                                <div v-else-if="video.loading" class="video-loading">
                                  <div class="spinner-border text-primary" role="status">
                                    <span class="sr-only">{{ t('loading') }}</span>
                                  </div>
                                  <p>{{ t('attractionEditingLoadingVideo') }}</p>
                                </div>
                                <div v-else-if="video.error" class="video-error">
                                  <p>{{ t('attractionEditingVideoLoadError') }}</p>
                                  <button class="retry-button" @click="retryVideo(index)">{{ t('attractionEditingRetryVideo') }}</button>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>

                    <label>
                      {{ t('attractionEditingActivityLocationLabel') }}<span>*</span>
                      <small @mouseover="showInfoTooltip = true" @mouseleave="showInfoTooltip = false" style="cursor: help; float: left;">
                        {{ t('attractionEditingWhenToChangeField') }} ℹ️
                      </small>
                    </label>
                    
                    <!-- Info tooltip -->
                    <div v-if="showInfoTooltip" class="info-tooltip">
                      <span v-html="t('attractionEditingLocationFieldTooltip')"></span>
                    </div>

                    <div class="trip-contact-input">
                      <gmap-autocomplete
                        id="attraction-name-input"
                        @place_changed="handlePlaceChanged"
                        :select-first-on-enter="true"
                        :placeholder="t('attractionEditingAutocompletePlaceholder')"
                        size=""
                        class="attraction-input"
                        :options="{ sessionToken: sessionToken, fields: ['geometry', 'name', 'formatted_address', 'place_id', 'website', 'rating'] }"
                      >
                      </gmap-autocomplete>
                    </div>

                    <!-- Explanation box -->
                    <div class="explanation-box">
                      <div class="explanation-section">
                        <div class="explanation-content">
                          {{ t('attractionEditingAutocompleteIntro') }}
                        </div>
                      </div>
                      
                      <div class="explanation-section important-note">
                        <div class="explanation-title">
                          <span class="icon">⚡</span> {{ t('attractionEditingImportantToKnow') }}
                        </div>
                        <div class="explanation-content">
                          {{ t('attractionEditingChooseSpecificPlace') }}
                          <br><br>
                          {{ t('attractionEditingExamplesTitle') }}
                          <ul
                            class="explanation-examples-list"
                            :style="isHebrew ? { paddingRight: '20px' } : { paddingLeft: '20px' }"
                          >
                            <li>{{ t('attractionEditingExampleFlight') }}</li>
                            <li>{{ t('attractionEditingExampleCarRental') }}</li>
                            <li>{{ t('attractionEditingExampleGuidedTour') }}</li>
                            <li>{{ t('attractionEditingExampleNature') }}</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- Stage 2: Show all other fields after place is selected -->
                  <template v-if="isPlaceSelected">
                    <div
                      v-if="showMasterFieldReference"
                      class="master-ref-banner"
                    >
                      {{ t('attractionMasterRefBanner') }}
                    </div>

                     <!-- Video Tutorials Section -->
                     <div class="video-tutorials-section">
                       <div class="video-tutorials-title">
                         <span class="icon">🎥</span> {{ t('attractionEditingTutorialsRecommendedTitle') }}
                       </div>
                       <div class="video-tutorials-list">
                         <div 
                           v-for="(video, index) in tutorialVideos" 
                           :key="index"
                           class="video-tutorial-item"
                         >
                           <div 
                             class="video-tutorial-card"
                             @click="toggleVideo(index)"
                           >
                             <div class="video-tutorial-header">
                               <div class="video-tutorial-title">{{ t(video.titleKey) }}</div>
                               <span class="video-tutorial-arrow" :class="{ 'is-open': selectedVideoIndex === index }">
                                 ▶
                               </span>
                             </div>
                           </div>
                           <transition name="slide-down">
                             <div v-if="selectedVideoIndex === index" class="video-container-wrapper">
                               <div class="tutorial-video-container">
                                 <video 
                                   v-if="video.videoUrl && !video.error"
                                   :ref="`video-${index}`"
                                   :src="video.videoUrl"
                                   controls
                                   class="tutorial-video"
                                   @loadstart="onVideoLoadStart(index)"
                                   @error="onVideoError(index)"
                                   @loadeddata="onVideoLoaded(index)"
                                   preload="none"
                                 >
                                   {{ t('videoTagNotSupported') }}
                                 </video>
                                 <div v-else-if="video.loading" class="video-loading">
                                   <div class="spinner-border text-primary" role="status">
                                     <span class="sr-only">{{ t('loading') }}</span>
                                   </div>
                                   <p>{{ t('attractionEditingLoadingVideo') }}</p>
                                 </div>
                                 <div v-else-if="video.error" class="video-error">
                                   <p>{{ t('attractionEditingVideoLoadError') }}</p>
                                   <button class="retry-button" @click="retryVideo(index)">{{ t('attractionEditingRetryVideo') }}</button>
                                 </div>
                               </div>
                             </div>
                           </transition>
                         </div>
                       </div>
                     </div>
                     
                     <!-- Show place name and change button when NOT in edit mode -->
                     <div v-if="currentPlace?.name" class="trip-contact-field" style="position: relative;">
                       <div style="margin-bottom: 10px;">
                         <div style="display: flex; align-items: center; justify-content: flex-end; direction: rtl; padding: 12px; background-color: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef; gap: 12px;">
                           <div style="flex: 1; text-align: right;">
                             <span style="color: #0D2F29; font-size: 14px; font-weight: 500; margin-left: 8px;">
                               {{ t('attractionEditingSelectedPlaceLabel') }}
                             </span>
                             <span style="color: #0D2F29; font-size: 16px; font-weight: 600;">
                               {{ currentPlace?.name }}
                             </span>
                           </div>
                           <button
                             type="button"
                             @click="returnToPlaceSelection"
                             style="cursor: pointer; background-color: #07A0C3; color: white; border: none; border-radius: 6px; padding: 8px 16px; font-size: 14px; font-weight: 500; transition: background-color 0.2s; flex-shrink: 0;"
                             @mouseover="$event.target.style.backgroundColor = '#0590b0'"
                             @mouseleave="$event.target.style.backgroundColor = '#07A0C3'"
                           >
                             {{ t('attractionEditingChangePlaceButton') }}
                           </button>
                           <small 
                             @mouseover="showChangePlaceExplanation = true" 
                             @mouseleave="showChangePlaceExplanation = false"
                             style="cursor: help; color: #07A0C3; font-size: 16px; flex-shrink: 0;"
                           >
                             ℹ️
                           </small>

                         </div>
                       </div>
                       <!-- Explanation tooltip -->
                       <div v-if="showChangePlaceExplanation" class="info-tooltip change-place-explanation">
                        <span v-html="t('attractionEditingChangePlaceTooltip')"></span>
                       </div>
                     </div>
                     
                     <!-- Show only change button when in edit mode -->
                     <div v-if="!currentPlace?.name" class="trip-contact-field" style="position: relative;">
                       <div style="margin-bottom: 10px;">
                         <div style="display: flex; align-items: center; justify-content: flex-end; direction: rtl; gap: 12px;">
                           <button
                             type="button"
                             @click="returnToPlaceSelection"
                             style="cursor: pointer; background-color: #07A0C3; color: white; border: none; border-radius: 6px; padding: 8px 16px; font-size: 14px; font-weight: 500; transition: background-color 0.2s; flex-shrink: 0;"
                             @mouseover="$event.target.style.backgroundColor = '#0590b0'"
                             @mouseleave="$event.target.style.backgroundColor = '#07A0C3'"
                           >
                             {{ t('attractionEditingChangePlaceButton') }}
                           </button>
                           <small 
                             @mouseover="showChangePlaceExplanation = true" 
                             @mouseleave="showChangePlaceExplanation = false"
                             style="cursor: help; color: #07A0C3; font-size: 16px; flex-shrink: 0;"
                           >
                             ℹ️
                           </small>
                         </div>
                       </div>
                       <!-- Explanation tooltip -->
                       <div v-if="showChangePlaceExplanation" class="info-tooltip change-place-explanation">
                        <span v-html="t('attractionEditingChangePlaceTooltip')"></span>
                       </div>
                     </div>
                     
                     <div class="trip-contact-field">
                       <label>{{ t('attractionEditingTitleLabel') }}<span>*</span></label>
                      <div
                        v-if="showMasterFieldReference"
                        class="master-ref-strip"
                      >
                        <span class="master-ref-template">{{ t('masterAttractionCompareMasterColumn') }}:</span>
                        <span class="master-ref-value">{{ formatMasterValue('title') }}</span>
                        <button type="button" class="master-ref-btn" @click="applyMasterField('title')">{{ t('accommodationMasterRefUseBase') }}</button>
                      </div>
                      <div class="trip-contact-input">
                        <input
                          v-model="localAttractionTitle"
                          :placeholder="t('attractionEditingTitlePlaceholder')"
                          type="text"
                          required
                        >
                        <!-- <button class="close-icon" type="reset"> לא הזנתם כותרת<img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fediting_attraction_page%2Fcross.png?alt=media&token=93a9ae89-45ab-4c2e-a790-e4d739fa397d" alt=""></button> -->
                      </div>
                    </div>

                    <div class="trip-contact-field">
                      <div v-if="isUserManager" class="ai-generate-btn-row">
                        <b-button
                          @click="creatcontentByAi"
                          variant="primary"
                          class="mt-2"
                        >
                          {{ t('attractionEditingCreateContentWithAi') }}
                        </b-button>
                      </div>
                      <InsertLinkToTextbox
                        :value="localAttractionText"
                        :setValue="val => localAttractionText = val"
                        textareaRef="attraction_information_editor"
                      />
                      <label>{{ t('attractionEditingDescriptionLabel') }}</label>
                      <div
                        v-if="showMasterFieldReference"
                        class="master-ref-strip"
                      >
                        <span class="master-ref-template">{{ t('masterAttractionCompareMasterColumn') }}:</span>
                        <span class="master-ref-value">{{ formatMasterValue('text') }}</span>
                        <button type="button" class="master-ref-btn" @click="applyMasterField('text')">{{ t('accommodationMasterRefUseBase') }}</button>
                      </div>
                      <div class="trip-contact-input">
                        <textarea
                          ref="attraction_information_editor"
                          :placeholder="t('attractionEditingDescriptionPlaceholder')"
                          v-model="localAttractionText"
                          >
                        </textarea>
                      </div>

                    </div>
                    <div class="trip-contact-field">
                      <label>{{ t('attractionEditingImageLabel') }}</label>
                      <h3 v-if="this.isUplowding()" >{{Math.round(this.uploadValue)}}%</h3>
                      <div class="trip-contact-input file-uploade">
                        <div class="btn-upload-group">
                          <button v-if="isUserManager" type="button" class="btn_upload btn_upload--pixabay" @click="openPixabayPicker">
                            <img src="https://pixabay.com/favicon.ico" class="btn_upload-logo" alt="">
                            {{ t('attractionEditingPixabayButton') }}
                          </button>

                          <span class="btn_upload btn_upload--local">
                            <input  type="file"
                            name="file"
                            accept="image/*"
                            class="input-img"
                            v-on:change="uploadImage"
                            id="file">
                            <span class="btn_upload-icon">⬆</span>
                            {{ t('attractionEditingUploadImage') }}
                          </span>
                        </div>

                        <!-- 16:9 preview box - same visual behavior as SingleRide -->
                        <div v-if="isNewAttractionImage" class="image-preview-wrapper">
                          <div class="attraction-image-top image-preview-16-9">
                            <div
                              class="attraction-image-top-bg"
                              :style="{ backgroundImage: `url('${newAttractionImage}')` }"
                            ></div>
                            <img
                              :src="newAttractionImage"
                              class="attraction-image-top-img"
                              :alt="newAttractionTitle"
                            >
                          </div>
                          <button
                            @click="removeImage"
                            type="button"
                            id="removeImage1"
                            value="x"
                            class="rmv">
                            x
                          </button>
                        </div>

                        <div class="trip-input-icon trip-input-icon2">
                          <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fediting_attraction_page%2Flink.png?alt=media&token=e70f1168-04b4-44fe-92f6-aa75bb313fc4" alt="">
                        </div>
                      </div>
                    </div>

                    <div v-if="isUserManager" class="attraction-media-uploads-section">
                      <VideoUpload
                        ref="videoUpload"
                        v-model="newAttractionVideoUrl"
                        :entity-id="newAttractionId"
                        :fallback-id="allRide?.ride?.id"
                        entity-type-prefix="attraction_id"
                        storage-folder="videos_and_audios"
                        instance-id="attraction"
                        @uploaded="handleVideoUploaded"
                        @removed="handleVideoRemoved"
                        @upload-progress="handleVideoUploadProgress"
                      />

                      <AudioUpload
                        ref="audioUpload"
                        v-model="newAttractionAudioUrl"
                        :entity-id="newAttractionId"
                        :fallback-id="allRide?.ride?.id"
                        entity-type-prefix="attraction_id"
                        storage-folder="videos_and_audios"
                        instance-id="attraction"
                        @uploaded="handleAudioUploaded"
                        @removed="handleAudioRemoved"
                        @upload-progress="handleAudioUploadProgress"
                      />

                      <!-- Multi-voucher row list -->
                      <div class="voucher-list">
                        <div
                          v-for="(url, index) in newAttractionVoucherUrls"
                          :key="index"
                          class="voucher-row"
                        >
                          <span class="voucher-row-icon">{{ isVoucherImage(url) ? '🖼️' : '📄' }}</span>
                          <span class="voucher-row-name">{{ getVoucherFilename(url) }}</span>
                          <button
                            type="button"
                            class="voucher-row-remove"
                            @click="removeVoucher(index)"
                          >✕</button>
                        </div>
                      </div>

                      <!-- Upload slot — hidden when at max capacity -->
                      <VoucherUpload
                        v-if="newAttractionVoucherUrls.length < 10"
                        ref="voucherUpload"
                        :value="null"
                        :entity-id="newAttractionId"
                        :fallback-id="allRide && allRide.ride ? allRide.ride.id : null"
                        entity-type-prefix="attraction_id"
                        storage-folder="videos_and_audios"
                        :instance-id="'attraction-' + newAttractionVoucherUrls.length"
                        :reset-after-upload="true"
                        :label="newAttractionVoucherUrls.length === 0 ? null : ''"
                        @uploaded="handleVoucherUploaded"
                        @upload-progress="handleVoucherUploadProgress"
                      />
                      <p v-else class="voucher-max-reached-msg">{{ t('voucherMaxReached') }}</p>

                      <!-- Master reference strip -->
                      <div
                        v-if="showMasterFieldReference && voucherMasterRefText !== '-'"
                        class="master-ref-strip"
                      >
                        <span class="master-ref-template">{{ t('masterAttractionCompareMasterColumn') }}:</span>
                        <span class="master-ref-value">{{ voucherMasterRefText }}</span>
                        <button type="button" class="master-ref-btn" @click="applyMasterField('voucherUrls')">{{ t('accommodationMasterRefUseBase') }}</button>
                      </div>
                    </div>

                    <div class="trip-contact-field">
                      <div class="map-explanation">
                        <h5 class="map-explanation-title">
                          {{ t('attractionEditingWantToChangeLocation') }}
                          <span 
                            class="info-icon" 
                            @click="showMapInfoTooltip = !showMapInfoTooltip"
                            @mouseenter="showMapInfoTooltip = true"
                            @mouseleave="showMapInfoTooltip = false"
                          >
                            ℹ️
                          </span>
                        </h5>
                        <div v-if="showMapInfoTooltip" class="map-info-tooltip">
                          <span v-html="t('attractionEditingMapTooltip')"></span>
                        </div>
                      </div>
                      <GlobalMap
                        class="single_ride_map11"
                        passed_class="single_ride_map"
                        @serchPointChange="handleUpdateserchpoint" >
                      </GlobalMap>
                      <div
                        v-if="showMasterFieldReference"
                        class="master-ref-strip master-ref-strip-map"
                      >
                        <span class="master-ref-template">{{ t('masterAttractionCompareMasterColumn') }}:</span>
                        <span class="master-ref-value">{{ formatMasterValue('location') }}</span>
                        <button type="button" class="master-ref-btn" @click="applyMasterField('location')">{{ t('accommodationMasterRefUseBase') }}</button>
                      </div>
                    </div>

                    <button id="submit-btn1" v-b-toggle.collapse-1 >{{ isAdvancedOptionsOpen ? t('attractionEditingHideAdvancedOptions') : t('attractionEditingShowAdvancedOptions') }}</button>
                    <b-collapse id="collapse-1" class="mt-2" v-model="isAdvancedOptionsOpen">
                      <!-- Category Selection - Only shown for ride managers -->
                      <template v-if="isUserManager">
                        <div class="trip-contact-field">
                          <label>{{ t('attractionEditingCategoryLabel') }}</label>
                          <div class="trip-contact-input">
                            <select
                              v-model="localAttractionCategory"
                              :placeholder="t('attractionEditingSelectCategory')"
                              class="trip-contact-select"
                            >
                              <option value="">{{ t('attractionEditingSelectCategory') }}</option>
                              <option v-for="category in categories" :key="category.id" :value="category.id">
                                {{ category.name }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <!-- Subcategory Selection (shown only if category is selected) -->
                        <div v-if="localAttractionCategory" class="trip-contact-field">
                          <label>{{ t('attractionEditingSubcategoryLabel') }}</label>
                          <div class="trip-contact-input">
                            <select
                              v-model="localAttractionSubcategory"
                              :placeholder="t('attractionEditingSelectSubcategory')"
                              class="trip-contact-select"
                            >
                              <option value="">{{ t('attractionEditingSelectSubcategory') }}</option>
                              <option 
                                v-for="subcategory in subcategoriesForSelectedCategory" 
                                :key="subcategory.id" 
                                :value="subcategory.id"
                              >
                                {{ subcategory.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </template>

                      <div class="trip-contact-field">
                        <label>{{ t('attractionEditingAddressLabel') }}</label>
                        <div
                          v-if="showMasterFieldReference"
                          class="master-ref-strip"
                        >
                          <span class="master-ref-template">{{ t('masterAttractionCompareMasterColumn') }}:</span>
                          <span class="master-ref-value">{{ formatMasterValue('address') }}</span>
                          <button type="button" class="master-ref-btn" @click="applyMasterField('address')">{{ t('accommodationMasterRefUseBase') }}</button>
                        </div>
                        <div class="trip-contact-input">
                          <input
                            v-model="localAttractionAddress"
                            :placeholder="t('attractionEditingAddressPlaceholder')"
                          >
                          <!-- <button class="close-icon" type="reset"> לא הזנת מיקום<img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fediting_attraction_page%2Fcross.png?alt=media&token=93a9ae89-45ab-4c2e-a790-e4d739fa397d" alt=""></button> -->
                        </div>
                      </div>
                      <div class="trip-contact-field">
                        <label>{{ t('website') }}</label>
                        <div
                          v-if="showMasterFieldReference"
                          class="master-ref-strip"
                        >
                          <span class="master-ref-template">{{ t('masterAttractionCompareMasterColumn') }}:</span>
                          <span class="master-ref-value">{{ formatMasterValue('link') }}</span>
                          <button type="button" class="master-ref-btn" @click="applyMasterField('link')">{{ t('accommodationMasterRefUseBase') }}</button>
                        </div>
                        <div class="trip-contact-input">
                          <input
                            v-model="localAttractionLink"
                            :placeholder="t('attractionEditingWebsitePlaceholder')"
                          >
                          <!-- <input type="text" class="input-remove" placeholder="הכנסת לינק לאתר"> -->
                        </div>
                      </div>
                      <div class="trip-contact-field">
                        <label>{{ t('attractionEditingNavigationAddressLabel') }}</label>
                        <div class="trip-contact-input">
                          <GlobalMapSerchAutoComplet
                            @handleserchPointChange="handleUpdateserchpoint" >
                          </GlobalMapSerchAutoComplet>
                        </div>
                      </div>
                    </b-collapse>

                    <!-- AI planning attributes. Admin-only while the feature is trialled. -->
                    <div v-if="userId === 1" class="trip-contact-field">
                      <AttractionEnrichmentPanel
                        ref="enrichmentPanel"
                        :attraction-id="newAttractionId"
                        :place-id="newAttractionPlaceId"
                        :title="localAttractionTitle"
                        :address="newAttractionAddress"
                        :text="localAttractionText"
                      />
                    </div>

                      <div class="trip-contact-field">
                    <p v-if="newAttractionErrores.length">
                      <label>{{ t('attractionEditingFixFieldsLabel') }}</label>
                      <ul class="input-errors" >
                        <li v-for="( error, index ) in newAttractionErrores" :key="index">{{ t(error) }}</li>
                      </ul>
                    </p>
                      </div>

                    <div v-if="isNewAttractionEditMode" class="mt-5 text-right">
                      <a class="trip-default-btn btn-sky" @click="handleSaveAttraction('update')">{{ t('save') }}</a>
                      <p v-if="pendingSave" class="voucher-save-pending-msg">{{ t('voucherSavePending') }}</p>
                    </div>
                    <div v-else class="trip-submit-button">
                      <a class="trip-default-btn btn-sky" @click="handleSaveAttraction('create')">{{ t('save') }}</a>
                      <p v-if="pendingSave" class="voucher-save-pending-msg">{{ t('voucherSavePending') }}</p>
                    </div>
                    <div v-if="this.allRide?.ride?.id" class="mt-5 text-right">
                      <a class="trip-default-btn btn-sky btn-greey" @click="ReturnToSingleRide()">{{ t('attractionEditingBackToTrip') }}</a>
                    </div>
                    <div v-else class="mt-5 text-right">
                      <a class="trip-default-btn btn-sky btn-greey" @click="gooToRideManagerAttraction()">{{ t('attractionEditingBackToAttractionsEdit') }}</a>
                    </div>
                  </template>
                  <div
                    v-if="allRide?.ride && isUserManager &&
                          compareToUserId(allRide.ride.authorId) &&
                          !isNewAttractionEditMode &&
                          !isPlaceSelected"
                    class="bottom-add-from-list-section"
                  >
                    <div class="centering">
                      <a
                        class="trip-default-btn btn-sky"
                        @click="serchAttractionToRide(newAttractionPlannedDateIndex)"
                      >
                        {{ t('attractionEditingOrChooseFromMyActivitiesList') }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <PageFooter />

    <!-- 16:9 Crop modal -->
    <div v-if="showCropModal" class="crop-modal-overlay" @click.self="cancelCrop">
      <div class="crop-modal">
        <div class="crop-modal-header">
          <h5>{{ t('attractionEditingCropTitle') }}</h5>
          <button type="button" class="crop-modal-close" @click="cancelCrop" aria-label="Close">&times;</button>
        </div>
        <div class="crop-modal-body">
          <div class="crop-mode-toggle">
            <button
              type="button"
              class="crop-mode-btn"
              :class="{ 'is-active': cropMode === 'fill' }"
              @click="cropMode = 'fill'"
            >
              {{ t('attractionEditingCropModeFill') }}
            </button>
            <button
              type="button"
              class="crop-mode-btn"
              :class="{ 'is-active': cropMode === 'fit' }"
              @click="cropMode = 'fit'"
            >
              {{ t('attractionEditingCropModeFit') }}
            </button>
          </div>

          <p class="crop-modal-hint">
            {{ cropMode === 'fill' ? t('attractionEditingCropHint') : t('attractionEditingFitHint') }}
          </p>

          <div class="crop-container">
            <img
              v-if="cropMode === 'fill'"
              ref="cropImage"
              :src="cropImageUrl"
              alt="Crop"
              class="crop-image"
            >
            <div v-else class="crop-fit-frame">
              <div
                class="crop-fit-bg"
                :style="{ backgroundImage: `url('${cropImageUrl}')` }"
              ></div>
              <img
                :src="cropImageUrl"
                alt="Preview"
                class="crop-fit-img"
              >
            </div>
          </div>
        </div>
        <div class="crop-modal-footer">
          <button type="button" class="crop-btn crop-btn-cancel" @click="cancelCrop">
            {{ t('attractionEditingCropCancel') }}
          </button>
          <button type="button" class="crop-btn crop-btn-apply" @click="applyCrop">
            {{ t('attractionEditingCropApply') }}
          </button>
        </div>
      </div>
    </div>

    <PixabayPicker
      :show="showPixabayPicker"
      :search-term="pixabaySearchTerm"
      @close="showPixabayPicker = false"
      @image-selected="handlePixabayImageSelected"
    />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { voucherFilename } from '@/utils/voucherFileName';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import GlobalMap from '@/components/GlobalMap';
import PageFooter from "@/components/PageFooter.vue";
import firebase from 'firebase/app';
import 'firebase/storage';
import GlobalMapSerchAutoComplet from '@/components/GlobalMapSerchAutoComplet';
import AttractionEnrichmentPanel from '@/components/AttractionEnrichmentPanel';
import SingleRideHeader from "@/components/SingleRideHeader";
import InsertLinkToTextbox from '@/components/InsertLinkToTextbox.vue';
import VoucherUpload from '@/components/VoucherUpload.vue';
import VideoUpload from '@/components/VideoUpload.vue';
import AudioUpload from '@/components/AudioUpload.vue';
import PixabayPicker from '@/components/Modals/PixabayPicker.vue';
import { storagePathForCrop } from '@/utils/sharedPlaceImages';
import { translationMixin } from "@/mixins/translationMixin";
import {
  getFloatingItemStyle,
  registerFloatingItem,
  unregisterFloatingItem,
  updateFloatingItem,
} from "@/services/floatingItems";

export default {
  name: 'AttractionEditing',
  mixins: [translationMixin],
  components: {
    GlobalMap,
    PageFooter,
    GlobalMapSerchAutoComplet,
    AttractionEnrichmentPanel,
    SingleRideHeader,
    InsertLinkToTextbox,
    VoucherUpload,
    VideoUpload,
    AudioUpload,
    PixabayPicker,
  },
  computed: {
    ...mapGetters([ 'allRide',
                    'newAttractionId',
                    'email',
                    'password',
                    'newAttractionTitle',
                    'newAttractionAddress',
                    'newAttractionId',
                    'userId',
                    'newAttractionText',
                    'newAttractionLink',
                    'newAttractionLat',
                    'newAttractionLng',
                    'newAttractionImage',
                    'newAttractionPlaceId',
                    'isNewAttractionImage',
                    'newAttractionpreviewImage',
                    'isNewAttractionEditMode',
                    'newAttractionGoogleImages',
                    'newAttractionErrores',
                    'newAttractionPlannedDate',
                    'isUserManager',
                    'compareToUserId',
                    'newAttractionPlannedDateIndex',
                    'newAttractionCategory',
                    'newAttractionSubcategory',
                    'categories',
                    'mapWereloded',
                    'appMap',
                    'currentPlace',
                    'referenceMasterAttraction',
                  ]),
    localAttractionText:{
        get () {
          return this.newAttractionText
        },
        set (value) {
          this.$store.commit('setNewAttractionText', value)
        }
      },
    localAttractionTitle:{
        get () {
          return this.newAttractionTitle
        },
        set (value) {
          this.updateTitle( value )
        }
      },
    pixabaySearchTerm() {
      return this.pixabaySearchTermResolved;
    },
    localAttractionAddress:{
        get () {
          return this.newAttractionAddress
        },
        set (value) {
          this.updateAddress( value )
        }
      },
    localAttractionLink:{
        get () {
          return this.newAttractionLink
        },
        set (value) {
          this.updateLink( value )
        }
      },
    localAttractionCategory: {
      get () {
        return this.newAttractionCategory
      },
      set (value) {
        this.updateCategory(value)
      }
    },
    localAttractionSubcategory: {
      get () {
        return this.newAttractionSubcategory
      },
      set (value) {
        this.updateSubcategory(value)
      }
    },
    newAttractionVideoUrl: {
      get () {
        return this.$store.getters.newAttractionVideoUrl
      },
      set (value) {
        this.$store.commit('setNewAttractionVideoUrl', value)
      }
    },
    newAttractionAudioUrl: {
      get () {
        return this.$store.getters.newAttractionAudioUrl
      },
      set (value) {
        this.$store.commit('setNewAttractionAudioUrl', value)
      }
    },
    newAttractionVoucherUrls() {
      return this.$store.getters.newAttractionVoucherUrls;
    },
    voucherMasterRefText() {
      const m = this.referenceMasterAttraction;
      if (!m || !Array.isArray(m.voucherUrls) || m.voucherUrls.length === 0) return '-';
      return m.voucherUrls.length === 1
        ? this.getVoucherFilename(m.voucherUrls[0])
        : `${m.voucherUrls.length} vouchers`;
    },
    subcategoriesForSelectedCategory() {
      if (!this.localAttractionCategory || !this.categories) return [];
      const category = this.categories.find(c => c.id === this.localAttractionCategory);
      return category ? category.subcategories || [] : [];
    },
    showMasterFieldReference() {
      return this.referenceMasterAttraction != null;
    },
    shouldShowFloatingButton() {
      return !!(
        this.allRide?.ride &&
        this.isUserManager &&
        this.compareToUserId(this.allRide.ride.authorId) &&
        !this.isNewAttractionEditMode
      );
    },
    floatingStyle() {
      return getFloatingItemStyle(this.floatingId, {
        top: "auto",
        transform: "none",
      });
    }
  },
  data() {
    return {
      sessionToken: null,
      floatingId: "floating-attraction-editing-add",
      value: "",
      lastChosenElement : null,
      uploadValue : 0,
      showInfoTooltip: false,
      isPlaceSelected: false,
      markerSetForEditMode: false, // Track if marker was set for edit mode
      isAdvancedOptionsOpen: false, // Track collapse state for advanced options
      showMapInfoTooltip: false, // Track map info tooltip visibility
      showChangePlaceExplanation: false, // Track explanation tooltip for change place link
      pendingSave: null,
      tutorialVideos: [
        {
          titleKey: 'attractionEditingTutorialVideoTitle1',
          videoUrl: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/tutorials%2Fadding_new_atraction_base_5.mp4?alt=media&token=2aaaf1d8-4cfa-42f9-89b3-3010f7d3d86c',
          loading: false,
          error: false
        },
      ],
      selectedVideoIndex: null, // Track which video is currently open
      cropMode: 'fill',
      showCropModal: false,
      cropImageUrl: null,
      pendingCropFile: null,
      pendingPixabayId: null,
      cropperInstance: null,
      showPixabayPicker: false,
      pixabaySearchTermResolved: '',
    };
  },
  watch: {
    // Watch for lat/lng to be loaded in edit mode
    newAttractionLat(newVal) {
      if (this.isNewAttractionEditMode && !this.markerSetForEditMode && newVal && this.newAttractionLng) {
        this.$nextTick(() => {
          this.waitForMapAndSetMarker(newVal, this.newAttractionLng);
          this.markerSetForEditMode = true;
        });
      }
    },
    newAttractionLng(newVal) {
      if (this.isNewAttractionEditMode && !this.markerSetForEditMode && this.newAttractionLat && newVal) {
        this.$nextTick(() => {
          this.waitForMapAndSetMarker(this.newAttractionLat, newVal);
          this.markerSetForEditMode = true;
        });
      }
    },
    cropMode(newMode) {
      if (!this.showCropModal) return;
      if (newMode === 'fit') {
        this.destroyCropper();
      } else if (newMode === 'fill') {
        this.$nextTick(() => this.initCropper());
      }
    },
    shouldShowFloatingButton() {
      this.syncFloatingState();
    },
  },
  methods:
  {
    ...mapActions([ 'register',
                    'validateAndupdateAppToken',
                    'removeAllMarkersFromGlobalMAp',
                    'createAttraction',
                    'updateAttraction',
                    'uploadAttractionIfEditMode',
                    'uplowadGoogleImages',
                    'setOneMarker',
                    'ReturnToSingleRide',
                    'serchAttractionToRide',
                    'creatcontentByAi',
                    'checkIfUserHasPlaceIdInAttractions',
                    'prefillSharedPlaceImage',
                    'fetchCategories'
                  ]),
    
    handleUpdateserchpoint( place ){
      this.updateLat( place.geometry.location.lat());
      this.updateLng( place.geometry.location.lng());
      this.$store.commit('setCurrentPlace', place)
    },
    gooToRideManagerAttraction(){
      this.$router.push('/ride_manager_attraction')
    },
    syncFloatingState() {
      this.$nextTick(() => {
        const root = this.$refs.floatingRoot;
        updateFloatingItem(this.floatingId, {
          visible: !!this.shouldShowFloatingButton,
          height: this.shouldShowFloatingButton && root ? root.offsetHeight : 0,
        });
      });
    },
    removeImage(){
      this.$store.commit('setNewAttractionImage', null);
      this.$store.commit('setNewAttractionPixabayPick', null);
    },
    getPlaceEnglishDetails(placeId) {
      return new Promise((resolve, reject) => {
        const service = new window.google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails(
          { placeId, fields: ['name'], language: 'en' },
          (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              resolve({
                name: place.name,
              });
            } else {
              reject(new Error(status));
            }
          }
        );
      });
    },
    async openPixabayPicker() {
      const placeId = this.currentPlace?.place_id || this.newAttractionPlaceId;
      if (placeId) {
        try {
          const { name } = await this.getPlaceEnglishDetails(placeId);
          this.pixabaySearchTermResolved = name || this.localAttractionTitle || '';
        } catch {
          this.pixabaySearchTermResolved = this.localAttractionTitle || '';
        }
      } else {
        this.pixabaySearchTermResolved = this.localAttractionTitle || '';
      }
      this.showPixabayPicker = true;
    },
    async handlePixabayImageSelected({ url, pixabayId }) {
      this.showPixabayPicker = false;
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        this.pendingCropFile = new File([blob], 'pixabay-image.jpg', { type: 'image/jpeg' });
        this.pendingPixabayId = pixabayId;
        this.cropImageUrl = URL.createObjectURL(blob);
        this.showCropModal = true;
        this.$nextTick(() => this.initCropper());
      } catch {
        alert(this.t('pixabayPickerErrorDownload'));
      }
    },
    uploadImage(e){
      const files = e.target.files || e.dataTransfer.files;
      const file = files[0];
      if (!file || !file.type.startsWith('image/')) return;

      this.pendingCropFile = file;
      this.pendingPixabayId = null;
      this.cropImageUrl = URL.createObjectURL(file);
      this.showCropModal = true;
      this.$nextTick(() => this.initCropper());

      e.target.value = '';
    },
    initCropper() {
      if (this.cropMode !== 'fill') return;
      if (!this.$refs.cropImage || this.cropperInstance) return;
      this.cropperInstance = new Cropper(this.$refs.cropImage, {
        aspectRatio: 16 / 9,
        viewMode: 1,
        dragMode: 'move',
        autoCropArea: 1,
        restore: false,
        guides: true,
        center: true,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
      });
    },
    destroyCropper() {
      if (this.cropperInstance) {
        this.cropperInstance.destroy();
        this.cropperInstance = null;
      }
    },
    cancelCrop() {
      this.destroyCropper();
      if (this.cropImageUrl) {
        URL.revokeObjectURL(this.cropImageUrl);
      }
      this.showCropModal = false;
      this.cropImageUrl = null;
      this.pendingCropFile = null;
      this.pendingPixabayId = null;
      this.cropMode = 'fill';
    },
    applyCrop() {
      if (!this.pendingCropFile) return;

      const pixabayId = this.pendingPixabayId;
      const placeId = this.newAttractionPlaceId;

      const uploadCroppedBlob = (blob) => {
        if (!blob) return;

        this.destroyCropper();
        if (this.cropImageUrl) URL.revokeObjectURL(this.cropImageUrl);
        this.showCropModal = false;
        this.cropImageUrl = null;
        this.pendingCropFile = null;
        this.pendingPixabayId = null;
        this.cropMode = 'fill';

        const today = new Date();
        const myTime = today.toUTCString().split(', ')[1].split(' ').join('_');
        const imageNewFileNamePrefix = this.allRide?.ride?.id?.toString() || ('attractio_id_' + this.newAttractionId.toString());

        this.$store.commit('setNewAttractionImage', null);
        this.$store.commit('setNewAttractionPixabayPick', null);
        this.uploadValue = 0;
        this.$store.commit('setNewAttractionUploadValue', 0);

        const pixabayPick = pixabayId ? { pixabayId, uploadedUrl: null } : null;
        const storagePath = storagePathForCrop({
          pixabayPick, placeId, ridePrefix: imageNewFileNamePrefix, timeStamp: myTime,
        });
        const storageRef = firebase.storage().ref(storagePath).put(blob);
        storageRef.on('state_changed',
          (snapshot) => {
            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.$store.commit('setNewAttractionUploadValue', this.uploadValue);
          },
          (error) => { console.log(error.message); },
          () => {
            this.uploadValue = 100;
            this.$store.commit('setNewAttractionUploadValue', 100);
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.$store.commit('setNewAttractionImage', url);
              if (storagePath.startsWith('places/')) {
                this.$store.commit('setNewAttractionPixabayPick', { pixabayId, uploadedUrl: url });
              }
            });
          }
        );
      };

      // Fit mode - upload original image as-is (no black borders added to the file)
      if (this.cropMode === 'fit') {
        uploadCroppedBlob(this.pendingCropFile);
        return;
      }

      // Fill mode - crop to exact 16:9
      const targetWidth = 1280;
      const targetHeight = 720;

      if (!this.cropperInstance) return;
      const canvas = this.cropperInstance.getCroppedCanvas({
        width: targetWidth,
        height: targetHeight,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      });

      if (!canvas) return;

      canvas.toBlob((blob) => {
        uploadCroppedBlob(blob);
      }, 'image/jpeg', 0.9);
    },
    isUplowding(){
      return this.uploadValue > 0
    },
    async handleSaveAttraction(mode) {
      const voucherRef = this.$refs.voucherUpload;
      if (voucherRef && voucherRef.isUploadInProgress()) {
        this.pendingSave = mode;
        return;
      }
      // Both saving paths clear newAttractionId and navigate away, destroying this
      // component, so the panel's values are read NOW and handed to the action.
      // The action writes them while it still has the id.
      const panel = this.$refs.enrichmentPanel;
      const enrichment = panel ? panel.payload() : null;

      if (mode === 'update') {
        await this.updateAttraction({ enrichment });
      } else {
        await this.createAttraction({ enrichment });
      }
    },
    handleVoucherUploaded(url) {
      const idx = this.newAttractionVoucherUrls.length;
      this.$store.commit('addVoucherUrl', url);
      this.$store.commit('clearVoucherUploadValue', idx);
      if (this.pendingSave) {
        const mode = this.pendingSave;
        this.pendingSave = null;
        if (mode === 'update') {
          this.updateAttraction();
        } else {
          this.createAttraction();
        }
      }
    },
    handleVoucherUploadProgress(progress) {
      this.$store.commit('setVoucherUploadValue', {
        index: this.newAttractionVoucherUrls.length,
        value: progress
      });
    },
    removeVoucher(index) {
      this.$store.commit('removeVoucherUrl', index);
    },
    isVoucherImage(url) {
      if (!url) return false;
      const lower = url.toLowerCase();
      return ['.jpg', '.jpeg', '.png', '.gif', '.webp'].some(ext => lower.includes(ext));
    },
    getVoucherFilename(url) {
      return voucherFilename(url, url || '');
    },
    handleVideoUploaded(url) {
      // Video URL is already set via v-model, this is just for any additional handling
      this.$store.commit('setNewAttractionVideoUrl', url);
      // Reset upload value after URL is received
      this.$store.commit('setNewAttractionVideoUploadValue', 0);
    },
    handleVideoRemoved() {
      this.$store.commit('setNewAttractionVideoUrl', null);
      this.$store.commit('setNewAttractionVideoUploadValue', 0);
    },
    handleVideoUploadProgress(progress) {
      // Update store with upload progress
      this.$store.commit('setNewAttractionVideoUploadValue', progress);
    },
    handleAudioUploaded(url) {
      // Audio URL is already set via v-model, this is just for any additional handling
      this.$store.commit('setNewAttractionAudioUrl', url);
      // Reset upload value after URL is received
      this.$store.commit('setNewAttractionAudioUploadValue', 0);
    },
    handleAudioRemoved() {
      this.$store.commit('setNewAttractionAudioUrl', null);
      this.$store.commit('setNewAttractionAudioUploadValue', 0);
    },
    handleAudioUploadProgress(progress) {
      // Update store with upload progress
      this.$store.commit('setNewAttractionAudioUploadValue', progress);
    },
    selectGoogleImage( event, imagUrl){
      event.target.classList.toggle('selected')
      if( this.lastChosenElement )
        this.lastChosenElement.target.classList.remove('selected');
      this.lastChosenElement = event
      this.$store.commit('setNewAttractionGoogleImage', imagUrl );
    },
    // handleUpdateserchpoint (place) {
    //   this.updateLat( place.geometry.location.lat());
    //   this.updateLng( place.geometry.location.lng());
    // },
    handlePlaceChanged(place) {
      this.handleautoCompliteForm(place);
      this.isPlaceSelected = true;
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      // Wait for map to load before setting marker
      this.$nextTick(() => {
        if ( place.geometry ){
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          this.waitForMapAndSetMarker(lat, lng);
        }
      });
    },
    async waitForMapAndSetMarker(lat, lng) {
      // Wait for the map to be loaded
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max wait
      
      while (attempts < maxAttempts && !this.mapWereloded && !this.appMap) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
      
      // Wait a bit more to ensure map is fully initialized
      await new Promise(resolve => setTimeout(resolve, 200));
      
      // Now set the marker
      if (lat && lng) {
        this.setOneMarker({ 
          latPoint: lat,
          lngPoint: lng,
          name: "the new point",
          draggable: true,
          onDragEnd: (newLat, newLng) => {
            // Update lat and lng when marker is dragged
            this.updateLat(newLat);
            this.updateLng(newLng);
          }
        });
      }
    },
    handleautoCompliteForm (place) {
      this.handleUpdateserchpoint(place)
      this.updateTitle( place.name )
      this.updateAddress( place.formatted_address )
      this.updateLink( place.website )
      this.updateRating( place.rating )
      //this.uplowadGoogleImages( place )
      this.updatePlaceId( place.place_id )
      this.prefillSharedPlaceImage( place.place_id )
      // Don't set marker here if map isn't shown yet - waitForMapAndSetMarker handles it
      
      
      if ( place.geometry ){
        // the map location will be updated automaticly
        this.$emit("serchPointChange", place);
      }
      this.checkIfUserHasPlaceIdInAttractions( place.place_id )
    },
    updateTitle ( value ) {
      this.$store.commit('setNewAttractionTitle', value)
    },
    updateAddress ( value ) {
      this.$store.commit('setNewAttractionAddress', value)
    },
    updateText ( value ) {
      this.$store.commit('setNewAttractionText', value)
    },
    updateLink ( value ) {
      this.$store.commit('setNewAttractionLink', value)
    },
    formatMasterValue(field) {
      const m = this.referenceMasterAttraction;
      if (!m) { return ''; }
      switch (field) {
        case 'title':
          return m.title != null && m.title !== '' ? String(m.title) : '-';
        case 'text':
          return m.text != null && m.text !== '' ? String(m.text) : '-';
        case 'address':
          return m.address != null && m.address !== '' ? String(m.address) : '-';
        case 'link':
          return m.link != null && m.link !== '' ? String(m.link) : '-';
        case 'voucherUrls':
          if (!Array.isArray(m.voucherUrls) || m.voucherUrls.length === 0) return '-';
          return m.voucherUrls.length === 1
            ? this.getVoucherFilename(m.voucherUrls[0])
            : `${m.voucherUrls.length} vouchers`;
        case 'location': {
          const parts = [];
          if (m.address) { parts.push(String(m.address)); }
          if (m.lat != null && m.lng != null) {
            parts.push(`(${m.lat}, ${m.lng})`);
          }
          return parts.length ? parts.join(' · ') : '-';
        }
        default:
          return '-';
      }
    },
    applyMasterField(field) {
      const m = this.referenceMasterAttraction;
      if (!m) { return; }
      switch (field) {
        case 'title':
          this.updateTitle(m.title || '');
          break;
        case 'text':
          this.updateText(m.text || '');
          break;
        case 'address':
          this.updateAddress(m.address || '');
          break;
        case 'link':
          this.updateLink(m.link || '');
          break;
        case 'voucherUrls':
          this.$store.commit('setNewAttractionVoucherUrls', m.voucherUrls || []);
          break;
        case 'location':
          this.updateAddress(m.address || '');
          if (m.place_id != null && m.place_id !== '') {
            this.updatePlaceId(m.place_id);
            this.prefillSharedPlaceImage(m.place_id);
          }
          if (m.lat != null && m.lng != null) {
            const lat = parseFloat(String(m.lat));
            const lng = parseFloat(String(m.lng));
            if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
              this.updateLat(lat);
              this.updateLng(lng);
            }
          }
          break;
        default:
          break;
      }
    },
    updateRating ( rate ) {
      this.$store.commit('setNewAttractionRate', rate)
    },
    updateLat (lat) {
      this.$store.commit('setNewAttractionLat', lat)
    },
    updateLng (lng) {
      this.$store.commit('setNewAttractionLng', lng)
    },
    updateImage ( value ) {
      this.$store.commit('setNewAttractionImage', value)
    },
    updatePlaceId ( value ) {
      this.$store.commit('setNewAttractionPlaceId', value)
    },
    updateCategory(value) {
      this.$store.commit('setNewAttractionCategory', value);
    },
    updateSubcategory(value) {
      this.$store.commit('setNewAttractionSubcategory', value);
    },
    returnToPlaceSelection() {
      // Reset to first stage to allow selecting a new place
      this.isPlaceSelected = false;
      this.markerSetForEditMode = false;
      // Optionally clear the marker from the map
      this.$store.dispatch('removeAllMarkersFromGlobalMAp');
    },
    toggleVideo(index) {
      // If clicking the same video, close it
      if (this.selectedVideoIndex === index) {
        this.closeVideo(index);
        return;
      }
      
      // Close the previously open video (if any)
      if (this.selectedVideoIndex !== null) {
        this.closeVideo(this.selectedVideoIndex);
      }
      
      // Open the newly selected video
      this.selectedVideoIndex = index;
      const video = this.tutorialVideos[index];
      if (video && video.videoUrl) {
        video.loading = true;
        video.error = false;
        
        // Wait for nextTick so the <video> element exists
        this.$nextTick(() => {
          const videoRef = this.$refs[`video-${index}`];
          if (videoRef && videoRef[0]) {
            const videoElement = videoRef[0];
            videoElement.load();
          }
        });
      }
    },
    closeVideo(index) {
      // Stop the video if it's playing
      const videoRef = this.$refs[`video-${index}`];
      if (videoRef && videoRef[0]) {
        const videoElement = videoRef[0];
        videoElement.pause();
        videoElement.currentTime = 0;
      }
      
      // If this is the open video, close it
      if (this.selectedVideoIndex === index) {
        this.selectedVideoIndex = null;
      }
    },
    retryVideo(index) {
      const video = this.tutorialVideos[index];
      if (video) {
        video.error = false;
        video.loading = true;
        
        this.$nextTick(() => {
          const videoRef = this.$refs[`video-${index}`];
          if (videoRef && videoRef[0]) {
            const videoElement = videoRef[0];
            videoElement.load();
          }
        });
      }
    },
    onVideoLoadStart(index) {
      // Video started loading
      if (this.tutorialVideos[index]) {
        this.tutorialVideos[index].loading = true;
      }
    },
    onVideoLoaded(index) {
      // Video loaded successfully
      if (this.tutorialVideos[index]) {
        this.tutorialVideos[index].loading = false;
      }
    },
    onVideoError(index) {
      if (this.tutorialVideos[index]) {
        this.tutorialVideos[index].error = true;
        this.tutorialVideos[index].loading = false;
      }
    }
  },
  async created() {
    this.$store.commit('setCurrentPlace', null)
    await this.removeAllMarkersFromGlobalMAp();
    await this.validateAndupdateAppToken();
    if (this.isUserManager){
      await this.fetchCategories();
    }
    await this.uploadAttractionIfEditMode();
    // If editing an existing attraction, show all fields immediately
    if (this.isNewAttractionEditMode) {
      this.isPlaceSelected = true;
      // Check if lat/lng are already loaded
      if (this.newAttractionLat && this.newAttractionLng) {
        this.$nextTick(() => {
          this.waitForMapAndSetMarker(this.newAttractionLat, this.newAttractionLng);
          this.markerSetForEditMode = true;
        });
      }
      // Otherwise, the watcher will handle it when lat/lng are loaded
    }
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    });
    registerFloatingItem({
      id: this.floatingId,
      priority: 35,
      anchor: "right",
      zIndex: 999,
    });
    this.syncFloatingState();
  },
  beforeDestroy() {
    unregisterFloatingItem(this.floatingId);
    this.cancelCrop();
    this.$store.commit('setReferenceMasterAttraction', null);
  },
  metaInfo() {
  const t = this.t;
  return {
    title: 'TripPlanner',
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'description', content: t('attractionEditingMetaDescription') },
    ],
  };
}
};
</script>

<style scoped>

.master-ref-banner {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.7;
  color: #0a3d6b;
  background: #dbeeff;
  border: 2px solid #5aabf0;
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 16px;
  white-space: pre-line;
  box-shadow: 0 2px 8px rgba(90, 171, 240, 0.18);
}

.master-ref-strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  font-size: 14px;
  margin-bottom: 8px;
  padding: 8px 10px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.master-ref-strip-map {
  margin-top: 10px;
}

.master-ref-template {
  font-weight: 600;
  color: #444;
  flex-shrink: 0;
}

.master-ref-value {
  flex: 1 1 180px;
  color: #1e1e1e;
  word-break: break-word;
  min-width: 0;
}

.master-ref-btn {
  flex-shrink: 0;
  cursor: pointer;
  background: #fff;
  border: 1px solid #07a0c3;
  color: #07a0c3;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
}

.master-ref-btn:hover {
  background: #e8f7fb;
}
[dir="ltr"] .master-ref-strip {
  text-align: left;
}
[dir="ltr"] .master-ref-template,
[dir="ltr"] .master-ref-value {
  text-align: left;
}

.attraction-editing-intro {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 500;
  color: #0D2F29;
  line-height: 1.6;
}

[dir="rtl"] .ai-generate-btn-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

[dir="ltr"] .ai-generate-btn-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

[dir="rtl"] .attraction-editing-intro {
  text-align: right;
  direction: rtl;
}

[dir="ltr"] .attraction-editing-intro {
  text-align: left;
  direction: ltr;
}

.btn-greey {
  background: #6c757d!important;
  border-color: #6c757d!important;
  color: #fff!important;
}

.bottom-add-from-list-section {
  margin: 0.2rem 0 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
}

.bottom-add-from-list-section .centering {
  width: 100%;
  display: flex;
  justify-content: center;
}

.after_page_header{
  margin-top: 23rem;
}

.brightness {
    background-color: white;
    display: inline-block;

}
.brightness img:hover {
    opacity: .5;
}
img{margin:10px;}
.selected{
  box-shadow:0px 12px 22px 1px #333; border:solid 3px yellow;
}

.input-errors{
  color: rgba(255, 0, 0, 1);
  font-size: 16px;
  padding: 0 1rem;
}

.container {
  padding: 0 1.5rem ;
}

.row {
  flex-direction: row-reverse;
}

[dir="ltr"] .row {
  flex-direction: row;
}

.trip-card-top {
  text-align: center;
  margin-bottom: 50px;
}
a.trip-btn-bg {
  display: inline-block;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #FFFFFF;
  background: #07A0C3;
  border-radius: 45px;
  padding: 9px 38px;
  margin-right: 50px;
}
a.trip-btn-outline {
  background: #FFFFFF;
  border: 1px solid #07A0C3;
  border-radius: 45px;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: rgba(13, 47, 41, 0.5);
  display: inline-block;
  width: 500px;
  padding: 6px 38px;
}
a.trip-btn-outline img{
  margin-left: 10px;
}
.trip-map-four {
  position: sticky;
  top: 237px;
}

.trip-card2-thumb {
  height: 232px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F7F7F7;
}
.trip-card2-thumb img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}
.trip-card2-thumb.plus img{
  width: auto;
  height: auto;
}

.trip-card2-wrap {
  margin: 0 25px;
}
.trip-card2-data {
  background: rgba(13, 47, 41, 0.3);
  text-align: center;
  padding: 16px;
  transition: all 0.4s;
}
.col-lg-4.col-sm-6:nth-child(1) .trip-card2-data{
  background: rgba(13, 47, 41, 0.3);
}
.col-lg-4.col-sm-6:nth-child(2) .trip-card2-data{
  background: #07A0C3;
}
.col-lg-4.col-sm-6:nth-child(3) .trip-card2-data{
  background: #0AD6A1;
}
.trip-card2-wrap:hover .trip-card2-data{
  background-color: #07A0C3;
}
.trip-card2-data h3{
  font-weight: 700;
  font-size: 18px;
  color: #FFFFFF;
}

.trip-activity-section {
  padding: 30px 0 80px;
}
.trip-activity-section .trip-sidebar {
  margin-left: 100px;
}

.trip-activity-section .trip-card-content {
  padding-left: 10px;
}
.trip-activity-section .trip-card-footer{
  padding: 0;
}
a.trip-card-btn {
  background: rgba(13, 47, 41, 0.5);
  border-radius: 45px;
  display: inline-block;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  padding: 6px 19px;
  transition: all 0.4s;
}
a.trip-card-btn:hover{
  background-color: #0A816D;
}
.trip-activity-section .trip-card-wrap {
  border: 5px solid #000;
  transition: all 0.4s;
  margin-bottom: 30px;

}
.trip-activity-section .trip-card-wrap:hover {
  border: 5px solid #07A0C3;

}
.trip-location {
  margin-right: 143px;
}
.trip-location ul li{
  font-size: 20px;
  color: #0D2F29;
  position: relative;
  margin-bottom: 15px;
  padding-right: 35px;
  text-align: right;
}
.trip-location ul li img{
  width: 22px;
  position: absolute;
  right: 0;
}

.trip-activity-top h4 {
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  text-align: center;
  color: #0D2F29;
  border-bottom: 2px solid #0D2F29;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.trip-activity-map {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 30px;
}

.trip-activity-map h6 {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: rgba(13, 47, 41, 0.5);
  margin: 0;
  margin-right: 20px;
}
.trip-activity-map h6 img{
  margin-left: 7px;
}
.trip-activity-map h5 {
  width: 120px;
  height: 24px;
  background: #000000;
  border: 1px solid rgba(13, 47, 41, 0.5);
  border-radius: 45px;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #FFFFFF;
  margin: 0;
}

.trip-contnet-section.mobile-device{
  display: none;
}

.trip-location.mobile-device{
  display: none;
}
.trip-hero-section.activity-page {
  padding: 120px 0 55px;
}
/* modal */
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 45px 55px;
}
.modal-dialog {
  max-width: 310px;

  margin: 1.75rem auto!important;
  margin-top: 10%!important;

}
.modal-content {
  background: #FFFFFF;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
  border-radius: 25px;
}
.trip-login-wrap{
  text-align: center;
}
.trip-login-field{
  margin-bottom: 10px;
}
.trip-login-field input{
  height: 30px;
  width: 100%;
  text-align: right;
  border: 1px solid #C1C0C0;
  border-radius: 22px;
  font-size: 12px;
  line-height: 14px;
  padding: 5px 15px!important;

  color: #C1C0C0;
}
button#trip-login-btn,
button#trip-login-btn2 {
  width: 100%;
  height: 30px;
  background: #34D0B6;
  border-radius: 22px;
  border: none;
  font-weight: 500;
  font-size: 12px;
  color: white;
  margin-top: 15px;
}
button#trip-login-btn2{
  background-color:  #07A0C3;
}

.trip-login-wrap h3{
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  color: #2E2E3A;
  margin-bottom: 15px;
  text-align: center
}
.trip-border-content{
  text-align: center;
  margin-top: 20px;
  margin-bottom: 12px;
}
.trip-border-content p{
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  text-align: center;
  position: relative;
  z-index: 0;
  display: inline-block;
  background-color: #fff;
}
.trip-border-content p:before,
.trip-border-content p:after {
  content: " ";
  left: -60px;
  top: 7px;
  width: 87%;
  height: 1px;
  display: inline;
  position: absolute;
  background-color: #2E2E3A;
  z-index: -1;
}
.trip-border-content p:after{
  left: auto;
  right: -60px;
}
.trip-login-bottom-btn{
  margin-top: 25px;
}
.trip-login-bottom-btn h5{
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  margin-bottom: 5px;
}

button.trip-login-btn {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  width: 129px;
  height: 30px;
  background: #07A0C3;
  border-radius: 22px;
  border: none;
}
.trip-login-check {
  text-align: right;
}
.trip-login-check h5{
  font-size: 9px;
  line-height: 11px;
  text-align: right;
  color: #2E2E3A;
  margin-top: 7px;
}
.trip-login-check label{
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
}
.trip-login-check input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.trip-login-check label {
  position: relative;
  cursor: pointer;
}

.trip-login-check label:before {
  content:'';
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #2E2E3A;
  padding: 0 6.5px;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-left: 5px;
  border-radius: 3px;
}

.trip-login-check input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 3px;
  right: 6px;
  width: 5px;
  height: 8px;
  border: solid #2E2E3A;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
/* contact page */
.trip-card-top.trip-card-top2{
  text-align: left;
  position: relative;
}

[dir="rtl"] .trip-card-top.trip-card-top2{
  text-align: right;
}
.trip-card-top h4 {
  font-weight: 600;
  font-size: 30px;
  line-height: 41px;
  color: #0D2F29;
  display: inline-block;
  position: absolute;
  top: 0;
  margin: 0;
  left: 50%;
  transform: translateX(-50%);
}
.trip-contact-wrap h4{
  display: none;
}
.trip-contact-field {
  margin-bottom: 15px;
}
.map-explanation {
  margin-bottom: 15px;
  text-align: right;
  direction: rtl;
  position: relative;
}

[dir="ltr"] .map-explanation {
  text-align: left;
  direction: ltr;
}
.map-explanation-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #0D2F29;
  margin: 0 0 0 0;
  text-align: right;
}

[dir="ltr"] .map-explanation-title {
  text-align: left;
}
.map-explanation-title .info-icon {
  cursor: pointer;
  margin-right: 8px;
  font-size: 20px;
  display: inline-block;
  vertical-align: middle;
  transition: transform 0.2s;
}
.map-explanation-title .info-icon:hover {
  transform: scale(1.1);
}
.map-info-tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
  min-width: 300px;
  max-width: 400px;
  font-size: 14px;
  line-height: 1.6;
  color: #495057;
  text-align: right;
  direction: rtl;
}

[dir="ltr"] .map-info-tooltip {
  right: auto;
  left: 0;
  text-align: left;
  direction: ltr;
}
.attraction-media-uploads-section {
  margin: 1.5rem 0;
  padding: 1rem 0;
  border-top: 1px solid #eee;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.trip-contact-field label{
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  color: rgba(13, 47, 41, 0.5)!important;
;
  display: block;
  margin-bottom: 5px;
  margin-right: 40px;
  }
  .trip-contact-field label span{
    color: #E42424;
  }

[dir="ltr"] .trip-contact-field label{
  text-align: left;
  margin-right: 0;
  margin-left: 40px;
}

  .trip-contact-input{
    position: relative;
  }
  .trip-contact-field img{
    width: 100%;
  }
  .trip-contact-input input,
  .trip-contact-input textarea{
    height: 56px;
    width: 100%;
    background: #FFFFFF;
    border: 2px solid #07A0C3!important;
    border-radius: 45px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: right;
    padding: 10px 20px!important;
    color: black !important;

  }

[dir="ltr"] .trip-contact-input input,
[dir="ltr"] .trip-contact-input textarea{
  text-align: left;
}
  .trip-contact-input textarea{
    height: 300px;
  }
  .trip-input-icon {
    position: absolute;
    top: 13px;
    right: 25px;
  }
  .trip-input-icon.trip-input-icon2 {
    display: none;
  }
  .trip-contact-input p{
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    margin:15px 0 0;
    color: rgba(228, 36, 36, 0.6)
  }
.trip-contact-input input::-webkit-input-placeholder,
.trip-contact-input textarea::-webkit-input-placeholder{ /* WebKit, Blink, Edge */
    color: rgba(13, 47, 41, 0.5);
    opacity: 1;
}
.trip-contact-input input:-moz-placeholder,
.trip-contact-input textarea:-moz-placeholder{ /* Mozilla Firefox 4 to 18 */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input::-moz-placeholder,
.trip-contact-input textarea::-moz-placeholder{ /* Mozilla Firefox 19+ */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input:-ms-input-placeholder,
.trip-contact-input textarea:-ms-input-placeholder{ /* Internet Explorer 10-11 */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}
.trip-contact-input input::-ms-input-placeholder,
.trip-contact-input textarea::-ms-input-placeholder{ /* Microsoft Edge */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}

.trip-contact-input input::placeholder,
.trip-contact-input textarea::placeholder{ /* Most modern browsers support this now. */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}

button#submit-btn1 {
  height: 56px;
  background: #0D2F29;
  border-radius: 12px;
  width: 100%;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #FFFFFF;
}
button#submit-btn2 {
    width: 188px;
    height: 42px;
    background: #DD6E42;
    border-radius: 45px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    margin: 0 auto;
}

.trip-submit-button{
  margin-top: 50px;
  text-align: center;
}

.trip-contact-form-section {
  padding-bottom: 150px;
}
.trip-contact-siderbar{
  background: rgba(225, 246, 251, 0.5);
  border-radius: 18px;
  padding: 25px;
  margin-left: 50px;
}
.trip-contact-siderbar h5{
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #E42424;
}

.trip-card2-thumb-resposive {
  display: none;
}
.trip-card2-thumb-resposive img{
  width: 100%;
  height: 100%;
}

.close-icon {
  border: 1px solid transparent;
  background-color: transparent;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
  position: absolute;
  left: 13px;
  top: 13px;
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  color: #FF0000;
}
.close-icon img{
  width: auto;
}
.input-remove:not(:valid) ~ .close-icon {
	display: none;
}


/* updloade img */


.btn_upload {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow: hidden;
  position: relative;
  padding: 0 20px;
  height: 58px;
  background: #ffffff;
  border: 2px solid #07A0C3;
  border-radius: 16px;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
  color: #07A0C3;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 8px rgba(7, 160, 195, 0.15);
  text-align: center;
}

.btn-upload-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 12px;
}

.btn_upload-icon {
  font-size: 17px;
  line-height: 1;
  pointer-events: none;
}

.btn_upload .btn_upload-logo {
  width: 22px !important;
  height: 22px !important;
  object-fit: contain;
  pointer-events: none;
  flex-shrink: 0;
}

.btn_upload--pixabay {
  border-color: #6366f1;
  color: #6366f1;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);
}

.btn_upload--local {
  border-color: #07A0C3;
  color: #07A0C3;
}

.btn_upload:hover,
.btn_upload:focus {
  background: #07A0C3;
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(7, 160, 195, 0.3);
}

.btn_upload--pixabay:hover,
.btn_upload--pixabay:focus {
  background: #6366f1;
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
}

.btn_upload input {
  cursor: pointer;
  height: 100%!important;
  position: absolute;
  filter: alpha(opacity=1);
  -moz-opacity: 0;
  opacity: 0;
  left: 0;
  top: 0;
  z-index: 99;
}


.preview1.it {
  position: absolute;
  top: 29px;
  width: 150px!important;
  height: 150px;
  left: 50%;
  transform: translateX(-50%);
}

.btn-rmv1{
  display: none;
}

.rmv {
  cursor: pointer;
  color: #fff;
  border-radius: 30px;
  display: inline-block;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 999;
  border: navajowhite;
  background-color: transparent;
  font-size: 32px;
}
img#ImgPreview {
  position: absolute;
  text-indent: 66em;
}

/* 16:9 preview wrapper to mimic SingleRide card image behavior */
.image-preview-wrapper {
  position: relative;
  margin-top: 16px;
}

.image-preview-16-9 {
  aspect-ratio: 16/9;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    rgba(7, 160, 195, 0.06) 0%,
    rgba(52, 208, 182, 0.08) 50%,
    rgba(7, 160, 195, 0.06) 100%
  );
  border-radius: 18px;
}

.image-preview-16-9 .attraction-image-top-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(24px);
  transform: scale(1.15);
  z-index: 0;
}

.image-preview-16-9 .attraction-image-top-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
  z-index: 1;
}













/*For bigger screen then normal 1500px desktop*/

@media (min-width: 1500px) {
    .container {
      max-width: 1360px;
    }
  }
  @media only screen and (max-width: 1399px) {
    .main-menu ul li{
        margin: 0 14px;
    }
    .main-menu ul li a{
        font-size: 16px;
    }
  }

  @media (min-width: 991px) {
      header.trip-header-section.sticky-menu {
          opacity: 0;
        }
        .trip-hero-section.sticky-menu{
          padding: 20px 0 0;
        }
    }

  @media (min-width: 1200px) and (max-width: 1499px) {
      .trip-sidebar{
          margin: 0;
      }

      .trip-activity-section .trip-sidebar {
          margin-left: 0;
      }
      a.trip-card-btn {
          padding: 6px 15px;
      }

  }


  @media only screen and (max-width: 1199px) {
      a.trip-header-social {
          display: none;
      }
      .main-menu ul li {
          margin: 0 15px;
      }
      .main-menu {
          margin-right: 30px;
      }
      .trip-sidebar{
          margin: 0;
      }
      .trip-card-footer {
          padding-left: 20px;
      }

      a.trip-card-btn {
          padding: 5px 10px;
      }
      .trip-location {
          margin-right: 0;
      }
      .trip-activity-section .trip-sidebar {
        margin-left: 30px;
    }
    .trip-card2-wrap {
        margin: 0 10px;
    }
    .trip-card2-data h3 {
        font-size: 16px;
    }

  }



  /*For Tablet Layout*/
  @media(max-width: 991px) {
      .main-menu {
          display: none;
      }
      .offcanves-menu{
          display: block;
      }
      .menu-bar{
          display: block;
      }
      .trip-menu-wrap {
          display: block;
          text-align: left;
          margin-left: 50px;
      }
      .trip-card2-wrap {
          margin: 0;
      }
      .trip-card2-data h3 {
          font-size: 18px;
      }
      a.trip-btn-outline {
          width: 400px;
      }

      .trip-location {
          display: none;
      }

  .trip-location.mobile-device{
      display: block;
      text-align: center;
    }
    .trip-location.mobile-device ul li{
      margin: 0 19px;
      font-size: 16px;
      display: inline-block;
    }
    .trip-activity-map {
      justify-content: center;
      margin-bottom: 14px;
      margin-top: 30px;
  }
  .trip-activity-section .trip-sidebar {
      margin-left: 0;
  }

  header.trip-header-section {
      padding: 18px 0;
      top: 0;
      background-color: white;
  }



  /* activity */
  .trip-hero-section.activity-page {
      padding: 109px 0 30px;
      margin-top: 0;
  }
  .trip-map-four {
      display: none;
  }

  .trip-hero-section.trip-page {
      padding: 110px 0 35px;
      margin: 0;
  }
  .trip-hero-section.home2 {
      margin: 0;
  }
  .trip-hero-section.home2 {
      padding: 95px 0 20px;
  }
  .trip-date-section.home2 {
      padding: 40px 0;
  }
  .trip-iconbox-section {
      padding: 60px 0 30px;
  }
  .trip-iconbox-wrap {
      margin-bottom: 30px;
  }

  .trip-card2-wrap {
    margin: 0 0 15px;
  }
  .trip-contact-siderbar{
    margin: 0 0 10px;
  }

  }


  /*For Wide Mobile Layout*/
  @media (max-width: 767px) {
      a.trip-header-btn {
          margin-right: 0;
      }
      .trip-logo {
          display: inline-block;
          width: 150px;
      }
      .trip-card-body {
          display: block;
      }
      .trip-card-thumb img{
          width: 100%;
      }
      .trip-card-thumb{
          margin-bottom: 20px;
      }

      a.trip-btn-outline {
          width: 270px;
      }
      .trip-card2-data h3 {
        font-size: 10px;
    }
    .trip-card2-thumb.plus img{
        width: 48px;
        height: 48px;
    }


    /* contact page */
    .trip-card-top h4{
        opacity: 0;
    }
    .trip-contact-wrap h4 {
        display: block;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        color: #0D2F29;
    }

    .trip-card-top.trip-card-top2{
        margin: 0;
    }
    .trip-contact-siderbar h5 {
        font-size: 12px;
        line-height: 16px;
    }
    .trip-contact-siderbar {
        padding: 10px 50px;
    }
    .trip-contact-field label {
        font-size: 12px;
    }
    .trip-contact-input input,
    .trip-contact-input textarea {
        font-size: 16px;
        line-height: 22px;
        padding: 10px 30px!important;
    }
    .trip-contact-input input {
        height: 44px;
    }
    .trip-contact-input textarea{
        height: 94px;
        border-radius: 15px;
    }
    .map-explanation {
        margin-bottom: 10px;
    }
    .map-explanation-title {
        font-size: 16px;
        line-height: 22px;
    }
    .map-explanation-title .info-icon {
        font-size: 18px;
        margin-right: 6px;
    }
    .map-info-tooltip {
        min-width: 250px;
        max-width: 320px;
        padding: 12px;
        font-size: 12px;
        margin-top: 6px;
    }
    .trip-input-icon {
        top: 12px;
        right: 15px;
    }
    .trip-input-icon img{
        width: 12px;
    }

    .trip-contact-input p {
        font-size: 12px;
        margin: 6px 0 0;
    }
    button#submit-btn1 {
        height: 30px;
        font-size: 12px;
        line-height: 21px;
    }
    button#submit-btn2 {
        height: 30px;
        font-size: 14px;
    }
    .trip-submit-button {
        margin-top: 15px;
    }
    .trip-contact-form-section {
        padding-bottom: 30px;
    }

    .close-icon {
        top: 2px;
        font-size: 12px;

    }
    .close-icon img{
        width: 12px;
    }
    .btn_upload {
        font-size: 14px;
        height: 52px;
    }
    .preview1.it {
        top: 22px;
        width: 60px!important;
        height: 60px;
    }
    .rmv {
        right: 44%;
        top: 21px;
        font-size: 12px;
    }


  }

  @media (max-width: 667px) {
      .trip-hero-section {
          padding: 5px 0 13px;
      }

      .responsive-width-left{
          width: 30%;
      }
      .responsive-width-right{
          width: 70%;
      }
      .trip-hero-content h1 {
          font-size: 16px;
          margin-bottom: 3px;
      }
      .map-icon {
          width: 20px;
          margin-left: 5px;
      }
      .trip-social ul li a img{
          width: 40px;
      }

  .trip-contnet-section{
      display: none;
  }

  .menu-bar {
      color: #000;
  }

  a.trip-btn-bg {
      font-size: 12px;
      padding: 5px 30px;
      margin-right: 20px;
  }
  a.trip-btn-outline {
      width: 170px;
      padding: 3px 38px;
      font-size: 14px;
  }
  a.trip-btn-outline img {
      margin-left: 10px;
      width: 17px;
  }
  .trip-card-top {
      text-align: center;
      margin-bottom: 20px;
  }

  .trip-card2-data {
      padding: 7px;
  }
  .trip-card2-thumb{
    display: none;
  }
  .trip-activity-top h4 {
      font-size: 16px;
      margin-bottom: 15px;
      padding-bottom: 2px;
  }
  .trip-location.mobile-device ul li {
      margin: 0 7px;
      font-size: 12px;
      padding-right: 20px;
  }
  .trip-location ul li img {
      width: 15px;
  }
  .trip-activity-map {
      margin-top: 15px;
  }
  .trip-card-header h4 {
      font-size: 16px;
  }
  .trip-card-content p {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  a.trip-card-btn {
      padding: 3px 14px;
      font-size: 12px;
  }
  .trip-card2-thumb {
    height: 130px;
}


  /* footer */
  footer.trip-footer-section {
      padding: 14px 0;
  }
  .footer-menu ul li {
      padding: 0;
      display: block;
      line-height: 1;
  }
  .footer-menu ul li a{
      font-size: 12px;
  }
  .footer-menu ul li:before {
      content: none;
  }
  .trip-footer-wrap img {
      margin-bottom: 9px;
      width: 110px;
  }

  /* ctivity */
  .trip-hero-section.activity-page {
      padding: 95px 0 15px;
  }
  .trip-sidebar-item-top {
      display: flex;
      text-align: center;
      justify-content: space-between;
  }
  .trip-sidebar-item-top.desktop{
      display: none;
    }
    .trip-sidebar-item-top.mobile {
      display: flex;
  }

  .trip-cta2-section {
      padding: 30px 0 10px;
  }
  .trip-cta2-wrap {
      margin-bottom: 20px;
  }
  .trip-cta2-title h2 {
      font-size: 14px;
      margin-bottom: 30px;
  }
  .trip-cta2-data p {
      font-size: 14px;
      line-height: 18px;
  }
  .trip-cta2-thumb img {
      width: 100px;
      height: 100%;
  }

  .trip-iconbox-thumb {
      height: auto;
  }
  .trip-iconbox-thumb img {
      width: 100px;
  }
  .trip-iconbox-data h3 {
      font-size: 14px;
      line-height: 18px;
  }
  .trip-iconbox-data p {
      font-size: 12px;
      line-height: 20px;
  }
  .trip-social ul li {
      margin: 0 12px;
  }
  .trip-login-wrap h3 {
    margin-bottom: 15px;
}
.trip-card2-thumb.plus {
    height: 90px;
    display: flex;
}
.trip-card2-thumb-resposive {
    display: block;
}


  }

  @media (max-width: 575px) {
    .responsive-width{
        width: 50%;
        margin: 0 auto;
    }
    .trip-card2-data h3 {
        font-size: 9px;
    }

  }

  /*For 320-384px up Mobile Layout*/
  @media (max-width: 479px) {

    .trip-card-footer {
          padding-left: 0;
      }
      .trip-card-body {
          padding: 7px 10px 20px;
      }

      .trip-card-header {
          display: block;
          text-align: center;
      }
      .trip-card-header h4 {
          margin-top: 15px;
      }

      a.trip-hero-btn {
          font-size: 12px;
      }

  }
  @media (max-width: 400px){
      .trip-menu-wrap {
          margin-left: 25px;
      }
  }

.smart-field-badge {
  font-size: 0.9em;
  background-color: #e0f7fa;
  color: #00796b;
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

.helper-text {
  color: #666;
  font-size: 1.3em;
  margin-top: 12px;
  display: block;
  line-height: 1.5;
}

.info-tooltip {
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 12px;
  max-width: 350px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  font-size: 1.1em;
  line-height: 1.5;
}

.change-place-explanation {
  right: 0;
  top: 100%;
  margin-top: 8px;
  text-align: right;
  direction: rtl;
}

.success-toast {
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 12px;
  border-radius: 6px;
  margin-top: 12px;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
  font-size: 1.2em;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Style for the autocomplete input */
::v-deep .gmap-autocomplete input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-size: 1.2em;
}

::v-deep .gmap-autocomplete input:focus {
  border-color: #00796b;
  box-shadow: 0 0 0 0.2rem rgba(0,121,107,.25);
}

.required-star {
  color: #dc3545;
  margin-right: 4px;
}

.explanation-box {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  font-size: 1.2em;
}

[dir="ltr"] .explanation-box {
  direction: ltr;
  text-align: left;
}

.explanation-section {
  margin-bottom: 16px;
}

.explanation-section:last-child {
  margin-bottom: 0;
}

.explanation-title {
  color: #2c3e50;
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 1.1em;
}

.explanation-content {
  color: #495057;
  line-height: 1.6;
}

.explanation-content ul {
  margin: 8px 0 8px 20px;
  padding: 0;
  list-style-type: none;
}

.explanation-content ul li {
  margin: 4px 0;
  position: relative;
  padding-right: 20px;
}

.explanation-content ul li:before {
  content: "•";
  position: absolute;
  right: 0;
  color: #4a90e2;
}

[dir="ltr"] .explanation-content ul {
  margin-left: 0;
  margin-right: 20px;
}

[dir="ltr"] .explanation-content ul li {
  padding-right: 0;
  padding-left: 20px;
}

[dir="ltr"] .explanation-content ul li:before {
  right: auto;
  left: 0;
}

.explanation-examples-list {
  margin: 8px 0;
}

.important-note {
  background-color: #fff3cd;
  border-radius: 6px;
  padding: 12px;
  margin-top: 16px;
}

.important-note .explanation-title {
  color: #856404;
}

.important-note .explanation-content {
  color: #856404;
}

.icon {
  margin-left: 8px;
}

/* Style for the autocomplete input */
::v-deep .gmap-autocomplete input {
  width: 100%;
  padding: 16px;
  border: 2px solid #ddd;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 1.2em;
  background-color: #fff;
}

::v-deep .gmap-autocomplete input:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74,144,226,0.2);
}

.trip-contact-select {
  width: 100%;
  height: 50px;
  border: 1px solid #E7E7E7;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #000;
  background-color: #fff;
  outline: none;
  transition: all 0.3s ease;
  text-align: right;
  direction: rtl;
}

[dir="ltr"] .trip-contact-select {
  text-align: left;
  direction: ltr;
}

.trip-contact-select:focus {
  border-color: #34D0B6;
  box-shadow: 0 0 0 2px rgba(52, 208, 182, 0.1);
}

.trip-contact-select option {
  padding: 10px;
  font-size: 16px;
  text-align: right;
  direction: rtl;
}

[dir="ltr"] .trip-contact-select option {
  text-align: left;
  direction: ltr;
}

/* Responsive styles */
@media (max-width: 667px) {
  .trip-contact-select {
    height: 40px;
    font-size: 16px;
    padding: 0 15px;
  }
  
  .trip-contact-select option {
    font-size: 16px;
  }
}

/* Video Tutorials Section */
.video-tutorials-section {
  margin-top: 24px;
  margin-bottom: 24px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  direction: rtl;
  text-align: right;
}

[dir="ltr"] .video-tutorials-section {
  direction: ltr;
  text-align: left;
}

.video-tutorials-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #0D2F29;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.video-tutorials-title .icon {
  font-size: 24px;
}

.video-tutorials-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.video-tutorial-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.video-tutorial-card {
  cursor: pointer;
  padding: 16px;
  transition: background-color 0.2s ease;
  min-height: 50px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: visible;
}

.video-tutorial-card:hover {
  background-color: #f0f0f0;
}

.video-tutorial-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.video-tutorial-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #0D2F29 !important;
  margin: 0 !important;
  flex: 1;
  text-align: right;
  display: block !important;
  word-wrap: break-word;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative;
  z-index: 1;
  overflow: visible;
}

[dir="ltr"] .video-tutorial-title {
  text-align: left;
}

.video-tutorial-arrow {
  font-size: 12px;
  color: #07A0C3;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.video-tutorial-arrow.is-open {
  transform: rotate(90deg);
}

.video-container-wrapper {
  padding: 0 16px 16px 16px;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.slide-down-enter-to,
.slide-down-leave {
  max-height: 1000px;
  opacity: 1;
}

.tutorial-video-container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background-color: #000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.tutorial-video {
  width: 100%;
  height: auto;
  display: block;
  max-height: 60vh;
}

.video-loading,
.video-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.video-loading p,
.video-error p {
  margin-top: 1rem;
  font-size: 14px;
  text-align: center;
}

.retry-button {
  margin-top: 1rem;
  padding: 8px 20px;
  background-color: #07A0C3;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.retry-button:hover {
  background-color: #0590b0;
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border.text-primary {
  color: #07A0C3;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Responsive styles for video section */
@media (max-width: 767px) {
  .video-tutorials-section {
    padding: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .video-tutorials-title {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .video-tutorial-title {
    font-size: 14px;
    line-height: 20px;
    display: block;
    width: 100%;
  }

  .video-tutorial-card {
    padding: 12px;
    min-height: 45px;
  }

  .video-tutorial-header {
    gap: 8px;
  }

  .tutorial-video {
    max-height: 50vh;
  }

  .video-loading,
  .video-error {
    min-height: 150px;
    padding: 1.5rem;
  }
}

/* Crop modal */
.crop-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.crop-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.crop-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
}

.crop-modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #0D2F29;
}

.crop-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
}

.crop-modal-close:hover {
  color: #0D2F29;
}

.crop-modal-body {
  padding: 16px 20px;
  overflow: auto;
  flex: 1;
  min-height: 0;
}

.crop-modal-hint {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #6c757d;
}

.crop-container {
  max-height: 60vh;
  min-height: 280px;
}

.crop-container .crop-image {
  max-width: 100%;
  display: block;
}

.crop-fit-frame {
  aspect-ratio: 16/9;
  width: 100%;
  max-height: 45vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(7, 160, 195, 0.06) 0%, rgba(52, 208, 182, 0.08) 50%, rgba(7, 160, 195, 0.06) 100%);
}

.crop-fit-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(24px);
  transform: scale(1.15);
  z-index: 0;
}

.crop-fit-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  position: relative;
  z-index: 1;
}

.crop-modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 20px;
  border-top: 1px solid #e9ecef;
}

.crop-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.crop-btn-cancel {
  background: #f5f5f5;
  color: #333;
}

.crop-btn-cancel:hover {
  background: #e9ecef;
}

.crop-btn-apply {
  background: #07A0C3;
  color: #fff;
}

.crop-btn-apply:hover {
  background: #0590b0;
}

.crop-mode-toggle {
  display: inline-flex;
  border-radius: 999px;
  background: #f1f3f5;
  padding: 3px;
  margin-bottom: 10px;
}

.crop-mode-btn {
  border: none;
  background: transparent;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  cursor: pointer;
  color: #495057;
}

.crop-mode-btn.is-active {
  background: #07A0C3;
  color: #fff;
}

.voucher-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.voucher-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 10px 14px;
}

.voucher-row-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.voucher-row-name {
  flex: 1;
  font-size: 1.3rem;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.voucher-row-remove {
  background: none;
  border: none;
  color: #999;
  font-size: 16px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
}

.voucher-row-remove:hover {
  color: #c00;
  background: #fee;
}

.voucher-save-pending-msg {
  font-size: 1.3rem;
  font-weight: 600;
  color: #0a6ea8;
  background: #e8f4fd;
  border: 1px solid #90caf9;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-top: 0.75rem;
}

.voucher-max-reached-msg {
  font-size: 1.4rem;
  font-weight: 600;
  color: #b05c00;
  background: #fff3e0;
  border: 1px solid #ffb74d;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
  text-align: right;
}

[dir="ltr"] .voucher-max-reached-msg {
  text-align: left;
}
</style>